import Alpine from 'alpinejs';

import {
  getMotionTier,
  initMotion,
  type MotionTier,
  subscribeMotion,
} from '../motion';

export type MotionStore = {
  tier: MotionTier;
  isFull: boolean;
  isLite: boolean;
  isReduce: boolean;
};

const toStore = (tier: MotionTier): MotionStore => ({
  tier,
  isFull: tier === 'full',
  isLite: tier === 'lite',
  isReduce: tier === 'reduce',
});

export const registerMotionStore = (): void => {
  initMotion();

  Alpine.store('motion', toStore(getMotionTier()));

  subscribeMotion((tier) => {
    const store = Alpine.store('motion') as MotionStore;
    Object.assign(store, toStore(tier));
  });
};
